import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft } from "lucide-react";

function renderContent(text) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push({ type: "list", items: list }); list = null; } };

  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); return; }
    if (line.trim().startsWith("- ") || line.trim().startsWith("• ")) {
      if (!list) list = [];
      list.push(line.trim().replace(/^[-•]\s*/, ""));
      return;
    }
    flush();
    if (/^\d+\.\s/.test(line.trim())) { blocks.push({ type: "h2", text: line.trim() }); return; }
    if (i === 0 || /^POLITIKA PRIVATNOSTI/i.test(line.trim())) { blocks.push({ type: "skip" }); return; }
    blocks.push({ type: "p", text: line.trim() });
  });
  flush();
  return blocks;
}

export default function PrivacyPolicy() {
  const { branding } = useAuth();
  const raw = branding?.privacy_policy || "";
  const blocks = renderContent(raw);

  return (
    <div className="stream-dark min-h-screen">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/"><Logo size="lg" light /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm" data-testid="privacy-back-home">
            <ArrowLeft size={16} /> Početna
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="privacy-policy-page">
        <h1 className="font-heading font-black text-2xl sm:text-3xl lg:text-4xl text-white mb-6">Politika privatnosti</h1>

        <div className="card-dark p-6 sm:p-10">
          {blocks.map((b, i) => {
            if (b.type === "skip") return null;
            if (b.type === "h2") return <h2 key={i} className="font-heading font-bold text-lg text-white mt-7 mb-3 first:mt-0">{b.text}</h2>;
            if (b.type === "list") return (
              <ul key={i} className="list-disc pl-5 space-y-1 text-white/70 text-sm leading-relaxed mb-3">
                {b.items.map((it, j) => <li key={j}>{it}</li>)}
              </ul>
            );
            return <p key={i} className="text-white/70 text-sm leading-relaxed mb-2">{b.text}</p>;
          })}
        </div>

        <div className="text-center mt-8">
          <Link to="/" className="text-[#FFD60A] hover:underline text-sm" data-testid="privacy-back-link">← Povratak na početnu</Link>
        </div>
      </main>
    </div>
  );
}
